import { fetchJson } from "@/services/api";

export type PushPlatform = "ios" | "android" | "web";

export interface ApiPushToken {
  id: number;
  platform: PushPlatform;
  device_name: string | null;
  language: string;
  last_used_at: string;
  created_at?: string;
}

interface RegisterPushTokenPayload {
  token: string;
  platform: PushPlatform;
  device_name?: string;
  language?: string;
}

interface RegisterPushTokenResponse {
  message: string;
  data: ApiPushToken;
}

/**
 * Enregistre / met à jour (idempotent) le jeton FCM de cet appareil.
 *
 * Peut renvoyer un 403 « email non vérifié » (middleware `verified`) — l'appelant est responsable
 * de réessayer une fois le compte vérifié, cf. `usePushNotifications`.
 */
export async function registerPushToken(
  payload: RegisterPushTokenPayload,
): Promise<RegisterPushTokenResponse> {
  return fetchJson<RegisterPushTokenResponse>("/v1/user/push-tokens", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

interface ListPushTokensResponse {
  message: string;
  data: ApiPushToken[];
}

/** Liste les jetons push actifs de l'utilisateur connecté (écran "Mes appareils"). */
export async function listPushTokens(): Promise<ApiPushToken[]> {
  const res = await fetchJson<ListPushTokensResponse>("/v1/user/push-tokens");
  return res.data;
}

/** Révoque un jeton push (logout, ou révocation manuelle depuis "Mes appareils"). */
export async function deletePushToken(id: number): Promise<void> {
  await fetchJson<void>(`/v1/user/push-tokens/${id}`, { method: "DELETE" });
}
